module.exports = __webpack_public_path__ + "static/media/iconeecg.ed9e10c9.png";